import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M8 4l0 16","key":"svg-1"}],["path",{"d":"M16 4l0 16","key":"svg-2"}],["path",{"d":"M4 8l4 0","key":"svg-3"}],["path",{"d":"M4 16l4 0","key":"svg-4"}],["path",{"d":"M4 12l16 0","key":"svg-5"}],["path",{"d":"M16 8l4 0","key":"svg-6"}],["path",{"d":"M16 16l4 0","key":"svg-7"}]]

const IconMovie = createReactComponent('outline', 'movie', 'Movie', __iconNode);

export default IconMovie;